import { Button } from "react-bootstrap";

interface DeleteProps {
    onDelete: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function Delete ({onDelete} : DeleteProps) {
    return (
        <>
            <Button variant='secondary' className="Univers-BoldCondensed" type='button' onClick={onDelete} >
                DELETE
            </Button>
        </>
    )
}